import React from 'react';

const DEFAULT_SERVICES = [
  {
    id: 1,
    name: "Men's & Women's Haircuts",
    price: '$50/$65',
    duration: '1 hour',
    description: "Professional haircuts tailored to your face shape, hair type, and personal style. Whether you prefer a classic look or a modern trend, our stylists ensure a clean, fresh, and confident finish."
  },
  {
    id: 2,
    name: "Men's & Women's Perms",
    price: '$120/$140',
    duration: '1.5 hours',
    description: "Customized perm services designed to add volume, texture, and long-lasting waves. From natural curls to stylish waves, we create a look that fits your lifestyle and hair condition."
  },
  {
    id: 3,
    name: "Men's & Women's Hair Coloring",
    price: '$180/$200',
    duration: '2 hours',
    description: "High-quality hair coloring services using professional products to achieve vibrant, natural, and long-lasting results. From gray coverage to full color transformations, we help you find the perfect shade."
  }
];

const ServicesSection = () => {
  const services = DEFAULT_SERVICES;

  return (
    <section className="services-section" id="services">
      <div className="container">
        <h2 className="section-title">Our Services</h2>
        <div className="services-grid">
          {services.map((service) => (
            <div key={service.id} className="service-card">
              <div className="service-image">
                <img src={`${process.env.PUBLIC_URL}/service/${service.id === 1 ? 'cutting.png' : service.id === 2 ? 'perm.png' : 'coloring.png'}`} alt={service.name} />
              </div>
              <h3 className="service-title">{service.name}</h3>
              <p className="service-description">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
